import timezoneStore from "./store/timezone-store"
import timezoneEventBus from "./events/event-bus"

export function timezoneModule({ store, eventBus }) {
  store.registerModule("timezone", timezoneStore)

  timezoneEventBus.init(eventBus)
}
